import { render, staticRenderFns } from "./MbomImpactTest.vue?vue&type=template&id=315fd8da&"
import script from "./MbomImpactTest.vue?vue&type=script&lang=js&"
export * from "./MbomImpactTest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports